import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getReturnDetailFetchSuccess,
    getReturnDetailFetchFailure,
    getReturnDetailChangelogFetchSuccess,
    getReturnDetailChangelogFetchFailure,
    createReturnDetailFetchSuccess,
    createReturnDetailFetchFailure,
    updateReturnDetailFetchSuccess,
    updateReturnDetailFetchFailure,
    patchReturnDetailFetchSuccess,
    patchReturnDetailFetchFailure,
    editReturnDetailEshopNoteFetchSuccess,
    editReturnDetailEshopNoteFetchFailure,
    confirmReturnDetailFetchSuccess,
    confirmReturnDetailFetchFailure,
} from './reducer';
import { ReturnDetailResType } from 'src/types/returnDetail';
import { ReturnType } from 'src/types/return';
import translate from '@translate';

const getReturnDetailFetchRequest = async (idReturn: string) => {
    const res = await api('get', `api/secure/returns/${idReturn}`);
    return res.data;
};

function* getReturnDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ReturnDetailResType = yield call((): any => getReturnDetailFetchRequest(action.payload));
        yield put(getReturnDetailFetchSuccess(response));
    } catch (error) {
        yield put(getReturnDetailFetchFailure({ error }));
    }
}

export function* getReturnDetailFetchWatch() {
    yield takeEvery('returnDetail/getReturnDetailFetch', getReturnDetailFetch);
}

const createReturnDetailFetchRequest = async (data: ReturnType) => {
    const res = await api('post', 'api/secure/returns', data);
    return res.data;
};

function* createReturnDetailFetch(action: { type: string; payload: ReturnType }) {
    try {
        const response: ReturnDetailResType = yield call((): any => createReturnDetailFetchRequest(action.payload));
        yield put(
            createReturnDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('returns.message.returnCreated') },
            })
        );
    } catch (error) {
        yield put(createReturnDetailFetchFailure({ error }));
    }
}

export function* createReturnDetailFetchWatch() {
    yield takeEvery('returnDetail/createReturnDetailFetch', createReturnDetailFetch);
}

const updateReturnDetailFetchRequest = async (params: { idReturn: string; data: ReturnType }) => {
    const res = await api('put', `api/secure/returns/${params.idReturn}`, params.data);
    return res.data;
};

function* updateReturnDetailFetch(action: { type: string; payload: { idReturn: string; data: ReturnType } }) {
    try {
        const response: ReturnDetailResType = yield call((): any => updateReturnDetailFetchRequest(action.payload));
        yield put(
            updateReturnDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('returns.message.returnUpdate') },
            })
        );
    } catch (error) {
        yield put(updateReturnDetailFetchFailure({ error }));
    }
}

export function* updateReturnDetailFetchWatch() {
    yield takeEvery('returnDetail/updateReturnDetailFetch', updateReturnDetailFetch);
}

const patchReturnDetailFetchRequest = async (params: { idReturn: string; data: Partial<ReturnType> }) => {
    const res = await api('patch', `api/secure/returns/${params.idReturn}`, params.data);
    return res.data;
};

function* patchReturnDetailFetch(action: { type: string; payload: { idReturn: string; data: Partial<ReturnType> } }) {
    try {
        const response: ReturnDetailResType = yield call((): any => patchReturnDetailFetchRequest(action.payload));
        yield put(
            patchReturnDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('returns.message.returnUpdate') },
            })
        );
    } catch (error) {
        yield put(patchReturnDetailFetchFailure({ error }));
    }
}

export function* patchReturnDetailFetchWatch() {
    yield takeEvery('returnDetail/patchReturnDetailFetch', patchReturnDetailFetch);
}

const editReturnDetailEshopNoteFetchRequest = async (params: { idReturn: string; data: { ESHOP_NOTE: string } }) => {
    const res = await api('put', `api/secure/returns/eshop-note/${params.idReturn}`, params.data);
    return res.data;
};

function* editReturnDetailEshopNoteFetch(action: {
    type: string;
    payload: { idReturn: string; data: { ESHOP_NOTE: string } };
}) {
    try {
        const response: ReturnDetailResType = yield call((): any =>
            editReturnDetailEshopNoteFetchRequest(action.payload)
        );
        yield put(
            editReturnDetailEshopNoteFetchSuccess({
                ...response,
                messageSuccess: { title: translate('returns.message.returnUpdate') },
            })
        );
    } catch (error) {
        yield put(editReturnDetailEshopNoteFetchFailure({ error }));
    }
}

export function* editReturnDetailEshopNoteFetchWatch() {
    yield takeEvery('returnDetail/editReturnDetailEshopNoteFetch', editReturnDetailEshopNoteFetch);
}

const confirmReturnDetailFetchRequest = async (params: { idReturn: string; data: ReturnType }) => {
    const res = await api('put', `api/secure/returns/${params.idReturn}?confirm=true`, params.data);
    return res.data;
};

function* confirmReturnDetailFetch(action: { type: string; payload: { idReturn: string; data: ReturnType } }) {
    try {
        const response: ReturnDetailResType = yield call((): any => confirmReturnDetailFetchRequest(action.payload));
        yield put(
            confirmReturnDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('returns.message.returnConfirmed') },
            })
        );
    } catch (error) {
        yield put(confirmReturnDetailFetchFailure({ error }));
    }
}

export function* confirmReturnDetailFetchWatch() {
    yield takeEvery('returnDetail/confirmReturnDetailFetch', confirmReturnDetailFetch);
}

const getReturnDetailChangelogFetchRequest = async (idReturn: string) => {
    const res = await api('get', `api/secure/returns/changelog/${idReturn}`);
    return res.data;
};

function* getReturnDetailChangelogFetch(action: { type: string; payload: string }) {
    try {
        const response: ReturnDetailResType = yield call((): any =>
            getReturnDetailChangelogFetchRequest(action.payload)
        );
        yield put(getReturnDetailChangelogFetchSuccess(response));
    } catch (error) {
        yield put(getReturnDetailChangelogFetchFailure({ error }));
    }
}

export function* getReturnDetailChangelogFetchWatch() {
    yield takeEvery('returnDetail/getReturnDetailChangelogFetch', getReturnDetailChangelogFetch);
}
